import { render, staticRenderFns } from "./JobForm.vue?vue&type=template&id=dd6a4b8a&scoped=true&"
import script from "./JobForm.vue?vue&type=script&lang=js&"
export * from "./JobForm.vue?vue&type=script&lang=js&"
import style0 from "./JobForm.vue?vue&type=style&index=0&id=dd6a4b8a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6a4b8a",
  null
  
)

export default component.exports